import { render } from "./TransferenciaDM.vue?vue&type=template&id=79274925"
import script from "./TransferenciaDM.vue?vue&type=script&lang=js"
export * from "./TransferenciaDM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__